import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { ResultsQueryKeys } from 'services/results/queryKeys'
import { getResultsVerificationV2 } from 'services/results/v2'
import type { GetResultsVerificationV2Params, GetResultsVerificationV2Response } from 'services/results/v2/types'

export const useGetResultsVerificationV2 = (
  params: GetResultsVerificationV2Params,
  options?: Omit<UseQueryOptions<GetResultsVerificationV2Response, Error>, 'queryKey'>
) => {
  return useQuery<GetResultsVerificationV2Response, Error>({
    ...options,
    queryKey: ResultsQueryKeys.ResultsVerificationV2(params),
    queryFn: ({ signal }) => getResultsVerificationV2(params, { signal })
  })
}
